import React, { useState, useRef, useEffect } from "react";
import "./BusinessInsurance.css";
import ReCAPTCHA from "react-google-recaptcha";
import TestimonialsSection from "../../common/testimonials-section/TestimonialsSection";
import { useDispatch, useSelector } from "react-redux";
import {
  submitEnquiryForm,
  resetEnquiryFormState,
} from "../../store/slices/enquiryFormSlice";

const WorkmenAdvantages = () => {
  const advantagesData = [
    {
      icon: "🏥",
      text: "This insurance will protect your employees in case of any injury or illness that is a result of their job, and help them back to work.",
    },
    {
      icon: "🐷",
      text: "Protect your own business by reducing the risk of financial loss against financial losses in case one of your employees injured.",
    },
    {
      icon: "📋",
      text: "Having a worker's compensation will limit your business's exposure to lawsuits, as it covers your employees' work-related injuries.",
    },
    {
      icon: "✔️",
      text: "It also helps protect your business by keeping it in line with The Workmen's Compensation Act, 1923.",
    },
    {
      icon: "🛡️",
      text: "You will also get additional protection from being sued, as once a claim is settled, employees can't file any additional claims for that incident.",
    },
  ];

  return (
    <section className="kfs-adv-section">
      <div className="kfs-adv-container">
        <div className="kfs-adv-header-wrapper">
          <h2 className="kfs-adv-heading">
            Advantages of Workmen Compensation Insurance Policy
          </h2>
          <p className="kfs-adv-description">
            If any of your employees are injured during the course of their
            work, they can file a lawsuit against you (their employer) in a
            civil court for damages for this injury. Such lawsuits, and any
            medical costs can end up costing your business a lot. But, a
            Workmen's Compensation Insurance your employees can get the help to
            recover from any such work-related injury or illness, while it also
            protects your business against financial losses.
          </p>
        </div>
        <div className="kfs-adv-grid">
          {advantagesData.map((item, index) => (
            <div className="kfs-adv-card" key={index}>
              <div className="kfs-adv-icon">{item.icon}</div>
              <div className="kfs-adv-text">
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ContractorsAllRisks = () => {
  const stakeholders = [
    {
      icon: "🏗️",
      title: "Construction companies",
      description:
        "Companies involved in the construction business can buy the policy to protect themselves financially during untoward circumstances.",
    },
    {
      icon: "💰",
      title: "Finance companies",
      description:
        "The Contractors' All Risk policy can also be bought by companies that provide financial support to finance the entire project. It helps if some untoward incidents occur during the construction phase or afterwards.",
    },
    {
      icon: "🏠",
      title: "Property owners",
      description:
        "The property owner can buy the policy where the construction is happening as they are the ones who have given the task of completing the building to the contractor.",
    },
    {
      icon: "👷",
      title: "Contractors and subcontractors",
      description:
        "With contractors and subcontractors employing workers to perform specific tasks concerning the completion of construction on time can also buy the policy.",
    },
  ];

  const keyFacts = [
    {
      icon: "⚠️",
      title: "High accident frequency rate",
      description:
        "The construction industry has a high accident frequency rate.",
    },
    {
      icon: "📊",
      title: "Widespread under-reporting",
      description:
        "In India, accidents that occur in workplaces are widely under-reported.",
    },
  ];

  return (
    <div className="kfs-car-container">
      <div className="kfs-hero-section kfs-car-hero">
        <div className="kfs-hero-badge">
          <i className="fas fa-hard-hat"></i> Construction Insurance
        </div>
        <h1 className="kfs-hero-title">
          Contractors' All Risks{" "}
          <span className="kfs-highlight">Insurance</span>
        </h1>
        <p className="kfs-hero-description">
          An all-risk policy with specific exclusions that provides coverage for
          damage to property and/or third-party property and bodily injury
          claims.
        </p>
        <div className="kfs-policy-availability">
          <i className="fas fa-check-circle"></i> Available for Principal,
          Contractor, or both
        </div>
      </div>

      <div className="kfs-content-grid">
        <div className="kfs-left-column">
          <div className="kfs-card kfs-definition-card">
            <div className="kfs-card-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h2 className="kfs-card-title">
              What is Contractors' All Risks Insurance?
            </h2>
            <p className="kfs-card-text">
              Contractors' All Risks is an{" "}
              <strong>all-risk policy with specific exclusions</strong> that
              provides coverage for damage to property and / or third-party
              property and bodily injury claims. It can be availed by the
              Principal or Contractor or both.
            </p>
          </div>

          <div className="kfs-card kfs-facts-card">
            <div className="kfs-card-icon">
              <i className="fas fa-chart-line"></i>
            </div>
            <h2 className="kfs-card-title">
              Important facts related to the Construction industry
            </h2>
            <div className="kfs-facts-list">
              {keyFacts.map((fact, index) => (
                <div className="kfs-fact-item" key={index}>
                  <div className="kfs-fact-icon">{fact.icon}</div>
                  <div className="kfs-fact-content">
                    <h3 className="kfs-fact-title">{fact.title}</h3>
                    <p className="kfs-fact-description">{fact.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="kfs-right-column">
          <div className="kfs-card kfs-who-needs-card">
            <div className="kfs-card-icon">
              <i className="fas fa-users"></i>
            </div>
            <h2 className="kfs-card-title">
              Who needs Contractors' All Risks Insurance?
            </h2>
            <p className="kfs-card-subtitle">
              The insurance policy can be availed of by those involved in the
              construction business in any way.
            </p>
            <div className="kfs-stakeholders-grid">
              {stakeholders.map((item, index) => (
                <div className="kfs-stakeholder-item" key={index}>
                  <div className="kfs-stakeholder-icon">{item.icon}</div>
                  <div className="kfs-stakeholder-content">
                    <h3 className="kfs-stakeholder-title">{item.title}</h3>
                    <p className="kfs-stakeholder-description">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="kfs-benefits-section">
        <div className="kfs-benefits-header">
          <i className="fas fa-umbrella"></i>
          <h2>Comprehensive All-Risk Coverage</h2>
        </div>
        <div className="kfs-benefits-grid">
          <div className="kfs-benefit-card">
            <i className="fas fa-building"></i>
            <h3>Property Damage</h3>
            <p>
              Coverage for contract works, construction materials, and temporary
              structures
            </p>
          </div>
          <div className="kfs-benefit-card">
            <i className="fas fa-gavel"></i>
            <h3>Third-Party Liability</h3>
            <p>
              Protection against third-party property damage and bodily injury
              claims
            </p>
          </div>
          <div className="kfs-benefit-card">
            <i className="fas fa-clock"></i>
            <h3>Maintenance Period</h3>
            <p>
              Extended coverage during defect liability and maintenance phases
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ContractorsPlantMachinery = () => {
  const coverageItems = [
    {
      icon: "🏗️",
      title: "Loss/damage to the contractors' construction equipment",
      description:
        "The policy covers the expense incurred due to loss or damage of equipment used at the construction site because of accidents arising from perils like fire, riots, strikes, malicious damage, earthquake, flood, storm etc",
    },
    {
      icon: "⚙️",
      title: "Damage caused at work, rest or during care",
      description:
        "If the insured property gets damaged at work or rest or due to maintenance, the policy will cover it.",
    },
  ];

  const exclusions = [
    {
      icon: "⚠️",
      title: "Negligence",
      description:
        "If the machinery gets damaged because of the insured's negligence or their representative, the policy will not cover the expenses.",
    },
    {
      icon: "💣",
      title: "Terrorism",
      description:
        "If the equipment incurs any damage due to an act of terrorism, it won't be covered.",
    },
    {
      icon: "🌍",
      title: "War and nuclear perils",
      description:
        "Damage caused to pieces of equipment due to factors like war and atomic hazards will not be covered under the insurance policy.",
    },
    {
      icon: "⏸️",
      title: "Lack of use and for undergoing test",
      description:
        "Damage or deterioration of machinery due to lack of use and undergoing tests is not covered under the policy.",
    },
    {
      icon: "📅",
      title: "Pre-existing damages",
      description:
        "Fault and damage to pieces of equipment which were pre-existing before the purchase of the policy will not be covered.",
    },
    {
      icon: "🔌",
      title: "Mechanical or electrical breakdown",
      description:
        "Failure of machinery due to electrical or mechanical breakdown not be covered under Contractor's Plant and Machinery insurance policy.",
    },
  ];

  const selectionTips = [
    {
      icon: "✅",
      title: "Proper coverage",
      description:
        "When choosing the right insurance policy, you need to check the coverage you are getting. You need to consider getting adequate coverage before deciding which insurance policy is good for yourself.",
    },
    {
      icon: "🎁",
      title: "Extra benefits",
      description:
        "An insurance policy with different benefits need to be considered. As most insurers will provide the standard coverage, look for additional benefits like 24x7 assistance when deciding which insurance policy is best for you.",
    },
    {
      icon: "🔄",
      title: "Hassle-free claims process",
      description:
        "Like in any other insurance policy, opting for a one for an insurer which has a hassle-free claims department needs to be considered. It will enable the claim to be settled quickly.",
    },
  ];

  return (
    <div className="kfs-cpm-container">
      <div className="kfs-hero-section kfs-cpm-hero">
        <div className="kfs-hero-badge">
          <i className="fas fa-tractor"></i> Equipment Insurance
        </div>
        <h1 className="kfs-hero-title">
          Contractors' Plant &{" "}
          <span className="kfs-highlight">Machinery Insurance</span>
        </h1>
        <p className="kfs-hero-description">
          The policy is designed to cover contractors' plant and machinery
          working at construction site like dumpers, excavators, rollers,
          drilling machines, etc.
        </p>
      </div>

      <div className="kfs-content-grid">
        <div className="kfs-left-column">
          <div className="kfs-card kfs-definition-card">
            <div className="kfs-card-icon">
              <i className="fas fa-question-circle"></i>
            </div>
            <h2 className="kfs-card-title">
              What is Contractors' Plant and Machinery Insurance?
            </h2>
            <p className="kfs-card-text">
              The policy is designed to cover contractors' plant and machinery
              working at construction site like dumpers, excavators, rollers,
              drilling machines, etc. Given that a major part of a contractor's
              investment goes into the above-mentioned machinery, the policy
              protects the business from any probable damage to plant and
              machinery used by the contractors to complete a task.
            </p>
          </div>

          <div className="kfs-card kfs-coverage-card">
            <div className="kfs-card-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h2 className="kfs-card-title">
              What does Contractors' Plant and Machinery Insurance Cover?
            </h2>
            <p className="kfs-card-subtitle">
              A Contractor's Plant and Machinery Insurance offers the coverage
              mentioned below:
            </p>
            <div className="kfs-coverage-list">
              {coverageItems.map((item, index) => (
                <div className="kfs-coverage-item" key={index}>
                  <div className="kfs-coverage-icon">{item.icon}</div>
                  <div className="kfs-coverage-content">
                    <h3 className="kfs-coverage-title">{item.title}</h3>
                    <p className="kfs-coverage-description">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="kfs-right-column">
          <div className="kfs-card kfs-exclusions-card">
            <div className="kfs-card-icon">
              <i className="fas fa-ban"></i>
            </div>
            <h2 className="kfs-card-title">What's not Covered?</h2>
            <p className="kfs-card-subtitle">
              KFS's Contractor's Plant and Machinery insurance policy does not
              cover losses due to the following:
            </p>
            <div className="kfs-exclusions-grid">
              {exclusions.map((exclusion, index) => (
                <div className="kfs-exclusion-item" key={index}>
                  <div className="kfs-exclusion-icon">{exclusion.icon}</div>
                  <div className="kfs-exclusion-content">
                    <h3 className="kfs-exclusion-title">{exclusion.title}</h3>
                    <p className="kfs-exclusion-description">
                      {exclusion.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="kfs-selection-section">
        <div className="kfs-selection-header">
          <i className="fas fa-clipboard-list"></i>
          <h2>
            How to choose the right Contractors' Plant and Machinery Insurance
            policy?
          </h2>
        </div>
        <p className="kfs-selection-intro">
          When choosing the right Contractors' Plant and Machinery insurance,
          you need to consider the following:
        </p>
        <div className="kfs-tips-grid">
          {selectionTips.map((tip, index) => (
            <div className="kfs-tip-card" key={index}>
              <div className="kfs-tip-icon">{tip.icon}</div>
              <h3 className="kfs-tip-title">{tip.title}</h3>
              <p className="kfs-tip-description">{tip.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const BusinessPlans = () => {
  const plans = [
    "General Liability Insurance",
    "Business Insurance Guides",
    "Trademark Registration",
    "Plate Glass Insurance",
    "Money Insurance Policy",
    "Fidelity Insurance",
    "Erection All Risk Insurance",
    "Workmen Compensation Insurance Policy",
    "Different Types of Business Insurance",
    "Contractors' All Risks Insurance",
    "Professional Indemnity Insurance",
    "Marine Cargo Insurance",
    "Business Ideas",
    "Machinery Breakdown Insurance",
    "Directors and Officers Liability Insurance",
    "Articles Related to Custom Duties",
    "Management Liability Insurance",
    "Franchisees",
    "Overview of Taxation",
    "Contractor's Plant and Machinery Insurance",
    "Debentures Guides",
    "Company Registration",
    "Business Terms",
    "Articles Related to Finance Guides",
  ];

  return (
    <div className="kfs-business-plans-container">
      <h2 className="kfs-business-plans-title">
        Other Business Insurance Plans
      </h2>
      <div className="kfs-business-plans-grid">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`kfs-business-plan-card ${
              plan === "Management Liability Insurance"
                ? "kfs-highlight-card"
                : ""
            }`}
          >
            {plan}
          </div>
        ))}
      </div>
    </div>
  );
};

const WorkmenTerms = () => {
  const termsData = [
    {
      title: "Employee Compensation Act 1923",
      description:
        'The Worker\'s Compensation Act 1923 (now called the Employee Compensation Act) states that "if a personal injury is caused to an employee by accident arising out of and in the course of his employment, their employer will be liable to pay compensation".',
    },
    {
      title: "Fatal Accident Act 1855",
      description:
        'This act provides compensation for damages to the families or dependents of a person who died by an "actionable wrong by some wrongful act, neglect, or default of another person."',
    },
    {
      title: "Occupational Disease",
      description:
        "This refers to any disease or illness that is caused (or aggravated) by the conditions of a person's employment. For example, it does not cover things like when someone gets the flu from fellow employee. But if that worker contracted asbestosis due to exposure to asbestos during the course of their work.",
    },
    {
      title: "Permanent total disability",
      description:
        "Any injury that is permanent and prevents the person from being able to work. This might include, blindness, paralysis, or loss of both legs.",
    },
    {
      title: "Permanent partial disability",
      description:
        "If an injury will not improve over time and leaves the person partially disabled. For example, loss of one leg, blindness in one eye or losing hearing in one ear.",
    },
    {
      title: "Temporary disability",
      description:
        "Here an injury creates a disability that prevents the person from working for a temporary amount of time, while they recover. Such injuries might include broken arms or an illness where your doctor says that you can't go back to work right away.",
    },
  ];

  return (
    <section className="kfs-terms-section">
      <div className="kfs-terms-container">
        <h2 className="kfs-terms-heading">
          Common Workmen Compensation terms simplified for you
        </h2>
        <div className="kfs-terms-grid">
          {termsData.map((term, index) => (
            <div className="kfs-term-card" key={index}>
              <h3 className="kfs-term-title">{term.title}</h3>
              <p className="kfs-term-description">{term.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const BusinessInsurance = () => {
  const coverageData = [
    {
      title: "Accidental Injury",
      desc: "If your employees suffer any bodily injury due to an accident that occurred during the course of their employment.",
      icon: "💥",
    },
    {
      title: "Occupational Illness and Diseases",
      desc: "Sometimes, workplaces can expose employees to some chemicals or allergens that can be harmful to them and cause illness. This policy will help cover any medical treatments if they get sick.",
      icon: "🦠",
    },
    {
      title: "Disability Cover",
      desc: "Workplace injuries may sometimes result in temporary or permanent disabilities (like loss of sight or limbs) and this insurance can help pay their medical bills and replace some of their lost wages.",
      icon: "♿",
    },
    {
      title: "Death Benefits",
      desc: "In the unfortunate case that an employee loses their life in a work-related accident, it covers for any funeral costs and provides death benefits to their beneficiaries.",
      icon: "⚰️",
    },
    {
      title: "Medical Coverage",
      desc: "Medical costs can be quite expensive, so this insurance covers your employees for any medical expenses from treating injuries due to accidents during their employment.",
      icon: "🏥",
    },
  ];

  // Enhanced form state with all fields
  const [formData, setFormData] = useState({
    clientName: "",
    clientEmail: "",
    clientPhone: "",
    serviceType: "",
    budget: "",
    referenceName: "",
    referenceEmail: "",
    projectDetails: "",
    agreeTerms: false,
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [globalError, setGlobalError] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef();

  // Validation function for all fields
  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!formData.clientName.trim()) {
      newErrors.clientName = "Name is required";
    } else if (formData.clientName.trim().length < 2) {
      newErrors.clientName = "Name must be at least 2 characters";
    }

    // Email validation
    if (!formData.clientEmail.trim()) {
      newErrors.clientEmail = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.clientEmail)) {
      newErrors.clientEmail = "Email is invalid";
    }

    // Phone validation
    if (!formData.clientPhone.trim()) {
      newErrors.clientPhone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.clientPhone)) {
      newErrors.clientPhone =
        "Please enter a valid 10-digit Indian mobile number";
    }

    // Terms validation
    if (!formData.agreeTerms) {
      newErrors.agreeTerms = "You must agree to the terms and conditions";
    }

    // CAPTCHA validation
    if (!captchaToken) {
      newErrors.captcha = "Please complete the reCAPTCHA verification";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const { loading, success, error } = useSelector(
    (state) => state.enquiryForm || {},
  );

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setGlobalError("");

    const payload = {
      fullname: formData.clientName,
      email: formData.clientEmail,
      mobile: formData.clientPhone,
      require_service: "Insurance Quote",

      projectDetails: formData.projectDetails,

      agreeToTerms: formData.agreeTerms,
      recaptchaToken: captchaToken,
    };

    dispatch(submitEnquiryForm(payload));
  };
  useEffect(() => {
    if (success) {
      setSubmitSuccess(true);

      setFormData({
        clientName: "",
        clientEmail: "",
        clientPhone: "",
        budget: "",
        require_service: "",
        projectDetails: "",
        agreeTerms: false,
      });

      setCaptchaToken(null);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }

      setErrors({});

      setTimeout(() => {
        setSubmitSuccess(false);
      }, 5000);

      dispatch(resetEnquiryFormState());
    }
  }, [success, dispatch]);
  useEffect(() => {
    if (error) {
      if (error.errors) {
        const backendErrors = {};

        if (error.errors.fullname)
          backendErrors.clientName = error.errors.fullname[0];
        if (error.errors.email)
          backendErrors.clientEmail = error.errors.email[0];
        if (error.errors.mobile)
          backendErrors.clientPhone = error.errors.mobile[0];
        if (error.errors.serviceType)
          backendErrors.serviceType = error.errors.serviceType[0];
        if (error.errors.budget) backendErrors.budget = error.errors.budget[0];

        setErrors(backendErrors);
        setGlobalError("Please fix the errors in the form before submitting.");
      } else {
        setGlobalError(error.message || "Something went wrong");
      }

      setCaptchaToken(null);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }

      dispatch(resetEnquiryFormState());
    }
  }, [error, dispatch]);
  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // Handle captcha change
  const handleCaptchaChange = (value) => {
    setCaptchaToken(value);
    if (errors.captcha) {
      setErrors((prev) => ({
        ...prev,
        captcha: "",
      }));
    }
  };

  // Budget options
  const budgetOptions = [
    { value: "", label: "Select Budget Range" },
    { value: "upto-10000", label: "Up to ₹10,000" },
    { value: "10001-25000", label: "₹10,001 - ₹25,000" },
    { value: "25001-50000", label: "₹25,001 - ₹50,000" },
    { value: "50001-100000", label: "₹50,001 - ₹1,00,000" },
    { value: "100001-250000", label: "₹1,00,001 - ₹2,50,000" },
    { value: "above-250000", label: "Above ₹2,50,000" },
  ];

  // Service type options
  const serviceTypeOptions = [
    { value: "", label: "Select Service Type" },
    { value: "workmen-compensation", label: "Workmen Compensation Insurance" },
    {
      value: "contractors-all-risks",
      label: "Contractors' All Risks Insurance",
    },
    {
      value: "contractors-plant-machinery",
      label: "Contractors' Plant & Machinery Insurance",
    },
    { value: "general-liability", label: "General Liability Insurance" },
    {
      value: "professional-indemnity",
      label: "Professional Indemnity Insurance",
    },
    { value: "marine-cargo", label: "Marine Cargo Insurance" },
    { value: "machinery-breakdown", label: "Machinery Breakdown Insurance" },
    { value: "other", label: "Other Business Insurance" },
  ];

  return (
    <div className="kfs-bi-page-wrapper">
      {/* ================= HERO & FORM SECTION ================= */}
      <section className="kfs-bi-hero-section">
        <div className="kfs-bi-container kfs-bi-hero-layout">
          {/* Left Pane: Content & Illustration */}
          <div className="kfs-bi-hero-left">
            <h1 className="kfs-bi-main-heading">Business Insurance</h1>

            <div className="kfs-bi-hero-image-wrapper">
              <img
                src="/images/insurance/bus1.png"
                alt="Business Insurance"
                className="kfs-bi-main-image"
              />
            </div>

            <div className="kfs-bi-features-row">
              <div className="kfs-bi-feature-card">
                <span className="kfs-bi-feature-icon">📄</span>
                <div className="kfs-bi-feature-text">
                  <span className="kfs-bi-feature-title">Quick Claim</span>
                  <span className="kfs-bi-feature-desc">Process</span>
                </div>
              </div>
              <div className="kfs-bi-feature-card">
                <span className="kfs-bi-feature-icon">₹</span>
                <div className="kfs-bi-feature-text">
                  <span className="kfs-bi-feature-title">Affordable</span>
                  <span className="kfs-bi-feature-desc">Premium</span>
                </div>
              </div>
              <div className="kfs-bi-feature-card">
                <span className="kfs-bi-feature-icon">📋</span>
                <div className="kfs-bi-feature-text">
                  <span className="kfs-bi-feature-title">Zero</span>
                  <span className="kfs-bi-feature-desc">Documentation</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Pane: Form Card */}
          <div className="kfs-bi-hero-right">
            <div className="kfs-bi-form-card">
              <div className="kfs-bi-form-header">
                <div className="kfs-bi-form-badge">
                  <span className="kfs-badge-icon">✨</span>
                  <span className="kfs-badge-text">Limited Time Offer</span>
                </div>
                <h2 className="kfs-bi-form-title">
                  Get Your{" "}
                  <span className="kfs-gradient-text">Business Insurance</span>{" "}
                  Quote
                </h2>
                <p className="kfs-bi-form-subtitle">
                  Fill the form and get personalized insurance plans within 24
                  hours
                </p>
              </div>
              {/* Success Message */}
              {submitSuccess && (
                <div className="kfs-bi-alert kfs-success-alert">
                  <div className="kfs-alert-icon">🎉</div>
                  <div className="kfs-alert-content">
                    <strong>Success!</strong> Your inquiry has been submitted
                    successfully. Our insurance expert will contact you within
                    24 hours.
                  </div>
                </div>
              )}

              {/* Global Error Message */}
              {globalError && (
                <div className="kfs-bi-alert kfs-error-alert">
                  <div className="kfs-alert-icon">⚠️</div>
                  <div className="kfs-alert-content">
                    <strong>Error!</strong> {globalError}
                  </div>
                </div>
              )}

              <form className="kfs-bi-form" onSubmit={handleSubmit}>
                {/* Name Field */}
                <div className="kfs-form-field-wrapper">
                  <div className="kfs-input-icon">
                    <svg
                      className="kfs-field-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <div className="kfs-input-group">
                    <input
                      type="text"
                      name="clientName"
                      placeholder=" "
                      value={formData.clientName}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      className={errors.clientName ? "kfs-error" : ""}
                    />
                    <label>Full Name *</label>
                  </div>
                  {errors.clientName && (
                    <div className="kfs-error-message">
                      <span className="kfs-error-icon">⚠️</span>
                      {errors.clientName}
                    </div>
                  )}
                </div>

                {/* Phone Field */}
                <div className="kfs-form-field-wrapper">
                  <div className="kfs-input-icon">
                    <svg
                      className="kfs-field-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </div>
                  <div className="kfs-input-group">
                    <input
                      type="tel"
                      name="clientPhone"
                      placeholder=" "
                      value={formData.clientPhone}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      maxLength="10"
                      className={errors.clientPhone ? "kfs-error" : ""}
                    />
                    <label>Mobile Number *</label>
                  </div>
                  {errors.clientPhone && (
                    <div className="kfs-error-message">
                      <span className="kfs-error-icon">⚠️</span>
                      {errors.clientPhone}
                    </div>
                  )}
                </div>

                {/* Email Field */}
                <div className="kfs-form-field-wrapper">
                  <div className="kfs-input-icon">
                    <svg
                      className="kfs-field-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <div className="kfs-input-group">
                    <input
                      type="email"
                      name="clientEmail"
                      placeholder=" "
                      value={formData.clientEmail}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      className={errors.clientEmail ? "kfs-error" : ""}
                    />
                    <label>Email Address *</label>
                  </div>
                  {errors.clientEmail && (
                    <div className="kfs-error-message">
                      <span className="kfs-error-icon">⚠️</span>
                      {errors.clientEmail}
                    </div>
                  )}
                </div>

                {/* Description Field */}
                <div className="kfs-form-field-wrapper">
                  <div className="kfs-input-icon kfs-textarea-icon">
                    <svg
                      className="kfs-field-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                  </div>
                  <div className="kfs-input-group">
                    <textarea
                      name="projectDetails"
                      placeholder=" "
                      value={formData.projectDetails}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      rows="4"
                      className="kfs-animated-textarea"
                    ></textarea>
                    <label>Tell us about your business needs</label>
                  </div>
                </div>

                {/* Terms and Conditions */}

                <div className="li-terms-group">
                  <input
                    type="checkbox"
                    name="agreeTerms"
                    checked={formData.agreeTerms}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                  <label htmlFor="kfs-checkbox-text">
                    I agree to receive loan updates and promotional from{" "}
                    <strong>Krishana Finconcept</strong> via WhatsApp and other
                    accept the{" "}
                    <a
                      href="/privacy-security-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms & Conditions
                    </a>
                  </label>
                  {errors.agreeTerms && (
                    <div className="kfs-error-message">
                      <span className="kfs-error-icon">⚠️</span>
                      {errors.agreeTerms}
                    </div>
                  )}
                </div>

                {/* reCAPTCHA */}
                <div className="kfs-recaptcha-container">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={
                      process.env.REACT_APP_GOOGLE_RECAPTCHA ||
                      "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                    }
                    onChange={handleCaptchaChange}
                  />
                  {errors.captcha && (
                    <div className="kfs-error-message">
                      <span className="kfs-error-icon">⚠️</span>
                      {errors.captcha}
                    </div>
                  )}
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="kfs-submit-button"
                  disabled={isSubmitting}
                >
                  <span className="kfs-button-text">
                    {isSubmitting ? "Processing..." : "Get Quote Now"}
                  </span>
                  {!isSubmitting && (
                    <svg
                      className="kfs-button-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  )}
                  {isSubmitting && <div className="kfs-spinner"></div>}
                </button>

                {/* Trust Badges */}
                <div className="kfs-trust-badges">
                  <div className="kfs-trust-item">
                    <span className="kfs-trust-icon">🔒</span>
                    <span className="kfs-trust-text">100% Secure</span>
                  </div>
                  <div className="kfs-trust-divider"></div>
                  <div className="kfs-trust-item">
                    <span className="kfs-trust-icon">⚡</span>
                    <span className="kfs-trust-text">Instant Quote</span>
                  </div>
                  <div className="kfs-trust-divider"></div>
                  <div className="kfs-trust-item">
                    <span className="kfs-trust-icon">💎</span>
                    <span className="kfs-trust-text">No Hidden Fees</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* ================= INFO SECTION ================= */}
      <section className="kfs-adv-section">
        <h2 className="kfs-adv-heading">
          What is Workmen Compensation Insurance?
        </h2>
        <div className="kfs-bi-text-content">
          <p>
            Workmen's Compensation Insurance (which is also known as Workers'
            compensation insurance or Employees Compensation Insurance) is a
            type of insurance policy that is there to provide coverage for your
            business's employees who are injured or become disabled as a result
            of their jobs.
          </p>
          <p>
            Even if you take all kinds of preventive measures, workplace
            accidents can unfortunately occur, and having this insurance will
            provide your employees with compensation without leaving your
            business at a financial loss.
          </p>
          <p>
            For example, if you own a construction business, and on a worksite,
            something falls from a higher level and onto one of your
            construction workers, causing them to break their leg. If you don't
            have workers' compensation insurance, they can sue and claim
            compensation from you for their medical expenses. This can end up
            costing your business significantly.
          </p>
          <p>
            Workmen's compensation insurance is set out under the Workmen's
            Compensation Insurance Act, 1923 and is there to protect you
            financially while still providing your employees with help in such
            situations.
          </p>
        </div>
      </section>

      {/* ================= COVERAGE SECTION ================= */}
      <section className="kfs-bi-coverage-section">
        <div className="kfs-bi-container">
          <h2 className="kfs-bi-section-heading">
            What does a Workmen Compensation Insurance cover?
          </h2>
          <p className="kfs-bi-subtext">
            When you get a Worker Compensation Insurance, you and your employees
            will be protected in case of...
          </p>
          <p className="kfs-bi-note">
            NOTE: Please refer to your policy wordings for detailed information
            about coverage, exclusions, and conditions.
          </p>

          <div className="kfs-bi-cards-grid">
            {coverageData.map((item, index) => (
              <div className="kfs-bi-coverage-card" key={index}>
                <div className="kfs-bi-card-icon-wrapper">
                  <span className="kfs-bi-card-emoji">{item.icon}</span>
                </div>
                <h3 className="kfs-bi-card-title">{item.title}</h3>
                <p className="kfs-bi-card-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <WorkmenAdvantages />
      <WorkmenTerms />
      <ContractorsAllRisks />
      <ContractorsPlantMachinery />
      <BusinessPlans />
      <TestimonialsSection />
    </div>
  );
};

export default BusinessInsurance;
